/* ============================================================================
   SNG — gedrag rond het mobiele menu en de zwevende knoppen

   Dawn opent de menulade met een <details>-element. Dat werkt, maar mist een
   paar dingen die je op een telefoon wel merkt:

   - de pagina eronder scrollt gewoon door;
   - de tabtoets loopt vanuit de lade de verborgen pagina in;
   - Escape sluit de lade niet;
   - na het sluiten is de focus kwijt;
   - de zwevende boekknop en het WhatsApp-belletje blijven over de lade liggen.

   Dit bestand vult precies die gaten aan. Het vervangt niets van Dawn en
   grijpt niet in op de navigatie zelf.
   ========================================================================== */

(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]),' +
    ' select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function drawerDetails() {
    return document.querySelector('#Details-menu-drawer-container');
  }

  function isOpen(details) {
    return !!(details && details.hasAttribute('open'));
  }

  /* Focusbare elementen in de lade.

     Bewust NIET filteren op `visibility`: zolang de lade openschuift staat hij
     op `visibility: hidden`, en die waarde erven de links. Wie daarop filtert,
     krijgt tijdens de overgang een lege lijst terug en verplaatst de focus dus
     nooit. We kijken alleen of het element daadwerkelijk ruimte inneemt. */
  function visibleFocusable(root) {
    return Array.prototype.slice.call(root.querySelectorAll(FOCUSABLE))
      .filter(function (node) {
        return node.getClientRects().length > 0 && getComputedStyle(node).display !== 'none';
      });
  }

  function setupDrawer() {
    var details = drawerDetails();
    if (!details || details.sngEnhanced) return;
    details.sngEnhanced = true;

    var summary = details.querySelector('summary');
    var drawer = details.querySelector('.menu-drawer');
    var scrollY = 0;

    function lock() {
      scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add('sng-menu-open');
      // De scrollpositie vasthouden zonder naar boven te springen.
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlock() {
      document.body.classList.remove('sng-menu-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
    }

    function close(returnFocus) {
      if (!isOpen(details)) return;
      details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
      unlock();
      if (returnFocus && summary) summary.focus();
    }

    // Openen en sluiten volgen het <details>-element zelf, zodat Dawn's eigen
    // knoppen en animaties blijven werken.
    /* De lade schuift open met een overgang. Zolang die loopt heeft de inhoud
       nog geen afmetingen, en dan levert een zoektocht naar focusbare elementen
       niets op. Daarom proberen we het een paar frames achter elkaar, tot de
       lade echt in beeld staat. */
    function focusFirstItem(attempt) {
      if (!isOpen(details) || !drawer) return;
      var first = visibleFocusable(drawer)[0];
      if (first) {
        try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
        return;
      }
      if ((attempt || 0) < 12) {
        requestAnimationFrame(function () { focusFirstItem((attempt || 0) + 1); });
      }
    }

    new MutationObserver(function () {
      if (isOpen(details)) {
        lock();
        focusFirstItem(0);
      } else {
        unlock();
      }
    }).observe(details, { attributes: true, attributeFilter: ['open'] });

    document.addEventListener('keydown', function (event) {
      if (!isOpen(details)) return;

      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        close(true);
        return;
      }

      if (event.key !== 'Tab' || !drawer) return;

      // Focus binnen de lade houden zolang hij open staat.
      var items = visibleFocusable(drawer);
      if (summary) items.unshift(summary);
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;

      if (event.shiftKey && (active === first || !drawer.contains(active) && active !== summary)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    });

    // Klik op een link in de lade: eerst netjes opruimen.
    if (drawer) {
      drawer.addEventListener('click', function (event) {
        if (event.target.closest('a[href]')) close(false);
      });
    }
  }

  /* Toetsenbord op een telefoon. Er is geen betrouwbare gebeurtenis voor
     "toetsenbord open", maar de zichtbare hoogte van het venster krimpt wél.
     Dat gebruiken we om de zwevende knoppen tijdelijk weg te halen, zodat ze
     niet over een invoerveld of een verzendknop komen te staan. */
  function setupKeyboardWatch() {
    var vv = window.visualViewport;
    if (!vv) return;

    var baseline = vv.height;

    function update() {
      if (window.innerWidth >= 750) {
        document.body.classList.remove('sng-keyboard-open');
        return;
      }
      // Meer dan een kwart van de hoogte weg? Dan staat er een toetsenbord.
      var shrunk = (baseline - vv.height) > baseline * 0.25;
      document.body.classList.toggle('sng-keyboard-open', shrunk);
    }

    vv.addEventListener('resize', update);
    window.addEventListener('orientationchange', function () {
      baseline = vv.height;
      document.body.classList.remove('sng-keyboard-open');
    });
  }

  /* ── Past de navigatie nog op één regel? ──────────────────────────────────
     Een vast breekpunt volstaat hier niet: hoeveel ruimte de navigatie nodig
     heeft hangt af van het aantal menu-items en de lengte van de labels, en
     die beheert de winkelier zelf in Shopify. Met alleen CSS zou een extra
     menu-item de labels weer in tweeën breken ("Over / ons").

     Daarom meten we het. Past het niet, dan gaat de header over op de lade —
     ook boven het vaste breekpunt. */

  var fitScheduled = false;

  function fitHeaderNav() {
    var header = document.querySelector('.header--has-menu');
    if (!header) return;

    var menu = header.querySelector('.header__inline-menu');
    if (!menu) return;

    // Eerst terug naar de brede stand, anders meten we onze eigen ingreep.
    header.classList.remove('header--sng-compact');

    // Onder 990px regelt Dawn de lade al; daar valt niets te meten.
    if (window.innerWidth < 990) return;

    var list = menu.querySelector('.list-menu--inline');
    if (!list) return;

    var needed = 0;
    Array.prototype.forEach.call(list.children, function (item) {
      needed += item.getBoundingClientRect().width;
    });
    // Tussenruimte tussen de items meetellen.
    var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
    if (list.children.length > 1) needed += gap * (list.children.length - 1);

    var available = menu.getBoundingClientRect().width;

    // Twee pixel speling: sub-pixelafrondingen mogen niet onnodig omschakelen.
    if (needed > available + 2) header.classList.add('header--sng-compact');
  }

  function scheduleFit() {
    if (fitScheduled) return;
    fitScheduled = true;
    requestAnimationFrame(function () {
      fitScheduled = false;
      fitHeaderNav();
    });
  }

  function setupHeaderFit() {
    scheduleFit();
    window.addEventListener('resize', scheduleFit);
    // Lettertypen komen later binnen en veranderen de tekstbreedte.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleFit).catch(function () {});
    }
  }

  function boot() {
    setupDrawer();
    setupKeyboardWatch();
    setupHeaderFit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // De Theme Editor bouwt de header opnieuw op bij het wijzigen van instellingen.
  document.addEventListener('shopify:section:load', function () {
    setupDrawer();
    scheduleFit();
  });
})();
